
<template>
  <div class="inquiry-company">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">用户管理</div>
        <div class="select-container" style="margin-top: 0px;">
          <div class="select-container-box">
            <span>查询：</span>
            <el-input
              placeholder="请输入用户名/手机号搜索"
              v-model="keyword"
              prefix-icon="el-icon-search"
              size="small"
              type="text"
              :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              class="search-input"
              clearable
            >
            </el-input>
          </div>

          <div class="select-container-box">
            <el-button
              size="small"
              type="info"
              plain
              class="query"
              @click="search(1)"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="list" style="width: 100%" size="medium" border>
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column
            prop="name"
            label="用户名"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号码"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="onLineBalance"
            label="余额"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="isEnable"
            label="状态"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                @change="changeStatus($event, scope.row)"
                active-color="#13ce66"
                v-model="scope.row.isEnable"
                :active-value="1"
                :inactive-value="2"
                inactive-color="#dadbdf"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import PageChange from "@/components/common/PageChange";
export default {
  name: "UserManage",
  data() {
    return {
      keyword: "",
      list: [],
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  components: {
    PageChange
  },
  async mounted() {
    this.search();
  },
  methods: {
    async search() {
      let res = await this.$api.getPlatformUser({
        Keyword: this.keyword,
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize
      });
      console.log(res);
      res.data.list.map(item => {
        if (item.isEnable) {
          item.isEnable = 1;
        } else {
          item.isEnable = 2;
        }
      })
      this.pageInfo.totalPages = res.data.total;
      this.list = res.data.list;
    },
    changeStatus(callback, row) {
      let text = "";
      if (callback == 1) {
        text = "启用";
        row.isEnable = 2;
      } else {
        text = "禁用";
        row.isEnable = 1;
      }
      this.$confirm(`是否变更状态为${text}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let status = "";
        let message = "";
        if (row.isEnable == 1) {
          status = 1;
          row.isEnable = 1;
          message = "禁用成功";
        } else {
          status = 2;
          row.isEnable = 2;
          message = "启用成功";
        }
        // 逻辑操作
        await this.$api.updatePlatformUserStatus({
          userId: row.userId,
          isEnable: status === 1 ? false : true
        });
        this.search();
        this.$message({
          type: "success",
          message
        });
      });
    }
  }
};
</script>
<style lang="stylus" >
.inquiry-company {
  .el-table {
    .el-table__body tbody td {
      border-bottom: 1px solid #eee;
    }

    .el-table__row:nth-of-type(even) {
      background: #fff;
      z-index: 9999;
    }
  }

  .total {
    .el-select__tags {
      top: 65%;
      height: 30px;
      overflow: auto;
    }

    .el-input__suffix {
      top: 6px;
    }

    .is-focus .el-input__suffix {
      top: 0px;
    }
  }

  .select-container-box:nth-child(1), .select-container-box:nth-child(3) {
    .el-input--small {
      width: 220px !important;
      height: 38px !important;
      min-width: 135px !important;
    }
  }

  .select-container-box:nth-child(6), .select-container-box:nth-child(7) {
    .el-input--small {
      width: 96px !important;
      height: 38px !important;
      min-width: 96px !important;
    }
  }

  .select-container-box:nth-child(9) {
    .add, .query {
      width: 80px !important;
    }
  }

  .scroll-box3 {
    width: 100%;
    max-height: 550px;
    overflow: auto;
    overflow-x: hidden;
  }

  .table-package {
    width: 100%;
    border-collapse: collapse;
    // border 1px #ddd solid
    border: none;
  }

  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);

    >tr th {
      width: 294px;
      text-align: center;
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom: 1px solid rgb(51, 137, 255);
      background-color: #f7f7f7;
    }
  }

  .table-tbodys {
    :hover {
      background: #c3e3ff;
    }

    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border: none;
      background-color: #fff;
    }

    td {
      width: 294px;
      border: 1px solid #e0e0e0;
      color: #666;
      border-top: none;
      vertical-align: middle;
    }
  }

  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 14px;
    }

    .row {
      font-size: 14px;
      background-color: #fff;
      font-weight: bold;

      >td {
        width: 294px;
        text-align: center;
        border: 1px solid #e0e0e0;
        // color: #666;
        border-top: none;
        font-weight: bold;
      }
    }
  }

  .hidden {
    display: none;
  }
}
</style>
